import { Link, NavLink } from "react-router-dom";
import footerLogo from "../assets/images/footer-logo.png";
import brand1 from "../assets/images/brand-1.png";
import brand2 from "../assets/images/brand-2.png";
import brand3 from "../assets/images/brand-3.png";
import brand5 from "../assets/images/brand-5.png";
import brand6 from "../assets/images/brand-6.png";
import brand7 from "../assets/images/brand-7.png";
import s1 from "../assets/images/s1.png";
import s2 from "../assets/images/s2.png";
import s3 from "../assets/images/s3.png";
import s4 from "../assets/images/s4.png";
import { useEffect, useState } from "react";

function Footer() {
  const handleClick = () => window.scrollTo(0, 0);


  
    const [currentLang, setCurrentLang] = useState("en");
  
    useEffect(() => {
      const checkHtmlLang = () => {
        const htmlLang = document.documentElement.lang;
        if (htmlLang && htmlLang !== currentLang) {
          setCurrentLang(htmlLang);
        }
      };
  
      // Check every 500ms
      const interval = setInterval(checkHtmlLang, 500);
  
      return () => clearInterval(interval);
    }, [currentLang]);
  
    const translations = {
      en: {
        home: "HOME",
        about: "ABOUT",
        products: "PRODUCTS",
        contact: "CONTACT",
       
      },
      nl: {
        home: "HOME",
        about: "OVER",
        products: "PRODUCTEN",
        contact: "CONTACT",
       
      },
      de: {
        home: "HEIN",
        about: "UM",
        products: "PRODUKTE",
        contact: "KONTAKT",
        
      },
    };
  
    const t = translations[currentLang] || translations.en;

  return (
    <div className="footer-bg">
      {/* Footer Logo */}
      <div className="footer-logo">
        <a href="/">
          <img className="mx-auto" src={footerLogo} alt="Footer Logo" />
        </a>
      </div>

      {/* Footer Brands */}
      <div className="footer-brands">
        <div className="container">
          <h3>EXPLORE bioKEMIX BRANDS</h3>
          <div className="slider-container">
            <ul className="slider">
              <li className="brand"><a href="http://www.lucgmbh.de/" target="_blank"><img src={brand1} alt="Brand 1" /></a></li>
              <li className="brand"><a href="http://promochemsolvents.com/" target="_blank"><img src={brand2} alt="Brand 2" /></a></li>
              <li className="brand"><a href="https://labscientific.com/" target="_blank"><img src={brand3} alt="Brand 3" /></a></li>
              <li className="brand"><a href="https://parkscientific.com/" target="_blank"><img src={brand5} alt="Brand 5" /></a></li>
              <li className="brand"><a href="https://brunschwig.nl/" target="_blank"><img src={brand6} alt="Brand 6" /></a></li>
              <li className="brand"><a href="https://instrulabo.nl/" target="_blank"><img src={brand7} alt="Brand 7" /></a></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer Navigation */}
      <div id="footer-nav-wrapper">
        <div className="container">
          {/* Contact */}
          <div className="footer-box f-contact">
            <h3>Contact</h3>
            <h4>+31 (85) 0130270</h4>
            <h5><a href="mailto:info@actu-all.com">info@actu-all.com</a></h5>
          </div>

          {/* Company */}
          <div className="footer-box f-company">
            <h3>Company</h3>
            <ul className="footer-nav">
              <li><NavLink to="/" onClick={handleClick} className='notranslate' translate="no"> {t.home}</NavLink></li>
              <li><NavLink to="/about" onClick={handleClick} className='notranslate' translate="no">{t.about}</NavLink></li>
              <li><NavLink to="/products" onClick={handleClick} className='notranslate' translate="no">{t.products}</NavLink></li>
              <li><NavLink to="/contact" onClick={handleClick} className='notranslate' translate="no">{t.contact}</NavLink></li>
            </ul>
          </div>

          {/* Divisions (linked to Products tabs) */}
          <div className="footer-box f-divisions">
            <h3>Divisions</h3>
            <ul className="footer-nav">
              <li><Link to="/products" state={{ activeTab: 1 }} onClick={handleClick}>Analyse.</Link></li>
              <li><Link to="/products" state={{ activeTab: 2 }} onClick={handleClick}>Aqua.</Link></li>
              <li><Link to="/products" state={{ activeTab: 3 }} onClick={handleClick}>Accurate.</Link></li>
              <li><Link to="/products" state={{ activeTab: 4 }} onClick={handleClick}>Again.</Link></li>
            </ul>
          </div>

          {/* Social Follow */}
          <div className="footer-box f-follow">
            <h3>Follow</h3>
            <ul className="footer-social">
              <li><NavLink to="#" className="hvr-pulse"><img src={s1} alt="Facebook" /></NavLink></li>
              <li><NavLink to="#" className="hvr-pulse"><img src={s2} alt="Twitter" /></NavLink></li>
              <li><NavLink to="#" className="hvr-pulse"><img src={s3} alt="LinkedIn" /></NavLink></li>
              <li><NavLink to="#" className="hvr-pulse"><img src={s4} alt="YouTube" /></NavLink></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="footer-copyright">
        <p>
          Copyright &copy; 2025, <span>Actu-ALL Chemicals</span>
        </p>
      </div>
    </div>
  );
}

export default Footer;
